<template>
  <div
    class="breadcrumb print-hidden"
    v-if="items"
    :style="{ backgroundColor: secondary }"
  >
    <div class="breadcrumb-item" v-for="(item, index) of items" :key="index">
      <span v-if="!item.path">{{ item.name }}</span>
      <router-link tag="a" :to="item.path" v-else>{{ item.name }}</router-link>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    items: {
      type: Array,
      default: null
    }
  },
  computed: {
    secondary() {
      return this.$store.state.app.scheme.secondary;
    }
  }
};
</script>

<style lang="scss" scoped>
.breadcrumb {
  /* background-color: $brand-secondary; */
  padding: 20px 60px;
  margin: 30px 0;
  display: flex;
  font-size: 14px;
  @media (max-width: 767px) {
    padding: 20px 40px;
  }
  @media (max-width: 575px) {
    padding: 20px;
  }
  &-item {
    &:first-child::before {
      content: " ";
      margin: 0;
    }
    &::before {
      margin: 0 10px;
      content: "»";
    }
    a {
      color: #505050;
    }
    span {
      color: #acacac;
    }
  }
}

@media print {
  .print-hidden {
    display: none !important;
  }
}
</style>
